/**
 * Confidence Levels Mock
 *
 * Shows how VaR and worst-case drawdown change across
 * different confidence levels (90%, 95%, 99%, 99.9%).
 */

const levels = [
  { level: '90%', var: -5.2, dd: -32, color: '#22c55e', risk: 'Standard' },
  { level: '95%', var: -8.5, dd: -42, color: '#3b82f6', risk: 'Default' },
  { level: '99%', var: -16.8, dd: -55, color: '#f59e0b', risk: 'Conservative' },
  { level: '99.9%', var: -24.1, dd: -68, color: '#ef4444', risk: 'Extreme' },
];

const maxDD = 70;

export default function ConfidenceLevelsMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Confidence Levels &mdash; VaR and Drawdown
      </div>
      <div className="platform-mock-body" style={{ padding: '0.75rem 1rem' }}>
        <div style={{
          fontSize: '0.5rem', color: '#64748b', marginBottom: '0.5rem',
          textAlign: 'center', fontStyle: 'italic',
        }}>
          Higher confidence = planning for rarer, worse outcomes
        </div>

        {/* Header */}
        <div style={{
          display: 'flex', gap: '0.375rem', fontSize: '0.5rem', color: '#64748b',
          marginBottom: '0.4rem', fontFamily: 'ui-monospace, monospace',
          borderBottom: '1px solid #334155', paddingBottom: '0.25rem',
        }}>
          <span style={{ width: 50 }}>Level</span>
          <span style={{ width: 55 }}>VaR</span>
          <span style={{ flex: 1 }}>Worst-Case Drawdown</span>
          <span style={{ width: 72, textAlign: 'right' }}>Profile</span>
        </div>

        {levels.map((l) => (
          <div key={l.level} style={{
            display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.5rem',
          }}>
            <span style={{
              width: 50, fontSize: '0.6875rem', fontWeight: 700,
              color: l.color, fontFamily: 'ui-monospace, monospace',
            }}>
              {l.level}
            </span>
            <span style={{
              width: 55, fontSize: '0.625rem', color: '#e5e7eb',
              fontFamily: 'ui-monospace, monospace',
            }}>
              {l.var}%
            </span>
            <div style={{ flex: 1, position: 'relative', height: 18 }}>
              <div style={{
                height: '100%',
                width: `${(Math.abs(l.dd) / maxDD) * 100}%`,
                background: `${l.color}18`,
                border: `1px solid ${l.color}44`,
                borderRadius: 3,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '0.375rem',
              }}>
                <span style={{
                  fontSize: '0.5625rem', fontWeight: 700, color: l.color,
                  fontFamily: 'ui-monospace, monospace',
                }}>
                  {l.dd}%
                </span>
              </div>
            </div>
            <span style={{
              width: 72, textAlign: 'right', fontSize: '0.5rem',
              fontWeight: 600, color: l.color,
            }}>
              {l.risk}
            </span>
          </div>
        ))}

        <div style={{
          fontSize: '0.4375rem', color: '#475569', marginTop: '0.25rem',
          fontStyle: 'italic', textAlign: 'center',
        }}>
          Same strategy, same trades &mdash; only the tail depth changes
        </div>
      </div>
      <div className="platform-mock-caption">
        At 99.9% confidence, plan for a -68% drawdown vs -42% at the standard 95% level.
      </div>
    </div>
  );
}
